import { type ColumnVisibility } from '@components/ColumnsVisibilityToggle';

import { INVOICE_TABLE_FIELDS } from './invoices';

const commercialManagementInvoicesVisibilityColumns: ColumnVisibility[] =
  Object.values(INVOICE_TABLE_FIELDS)
    .filter(field => field.enableVisibility)
    .map(field => ({
      label: field.label,
      key: field.id,
      hide: false,
    }));

export { commercialManagementInvoicesVisibilityColumns };
